import React, { useEffect, useState } from 'react';
import {
    Grid, Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { json, useParams } from 'react-router-dom';
import { fetchclothstklump } from '../../Store/PHPSlice/clothStock';
import { selectClothstklumplist } from '../Selectors/UploadStock/ReadyMSelector';
import { insertClothIssueLump } from '../../Store/PHPSlice/Cutting/clothIssue';


const ClothIssueLump = () => {

    const { Id } = useParams();
    const [lumpRows, setLumpRows] = useState([]);
    const [newLumprows, setNewLumprows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [newTotMtr, setNewTotMtr] = useState(0);
    const dispatch = useDispatch();
    const lumplist = useSelector(selectClothstklumplist);

    useEffect(() => {
        dispatch(fetchclothstklump(Id));
    }, [Id]);

    useEffect(() => {
        if (lumplist?.data3?.length > 0) {
            const valdata = JSON.parse(JSON.stringify(lumplist.data3));
            const totmtr = lumplist.data3.reduce((acc, lump) => acc + parseInt(lump.mtr), 0);
            setLumpTotMtr(totmtr);
            setLumpRows(valdata);

            const valdata2 = JSON.parse(JSON.stringify(lumplist.data2));
            const totmtr2 = lumplist.data2.reduce((acc, lump) => acc + parseInt(lump.mtr), 0);
            setNewTotMtr(totmtr2);
            setNewLumprows(valdata2);
        }
    }, [lumplist]);
    // console.log(lumplist)

    const handleLumpSelection = (index) => {
        const newRows = [...lumpRows];
        newRows[index].selected = !newRows[index].selected;
        setLumpRows(newRows);
    };

    const handleLumpSelection2 = (index) => {
        const newRows = [...newLumprows];
        newRows[index].selected2 = !newRows[index].selected2;
        setNewLumprows(newRows);
    };

    const handleLumpColor = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].color = value;
        setLumpRows(updateLumps);
    };

    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].mtr = value;
        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.mtr) || 0;
            return sum + mtrValue;
        }, 0);
        setLumpTotMtr(totalMtr);
        setLumpRows(updateLumps);
    };

    const handleAddlump = () => {
        let selectedRows = lumpRows.filter(row => row.selected);
        const newTotmtr = selectedRows.reduce((acc, row) => acc + parseFloat(row.mtr), 0);
        selectedRows = selectedRows.map(row => ({
            ...row,
            selected2: false
        }));
        const newTotmtrprev = newLumprows?.reduce((acc, row) => acc + parseFloat(row.mtr), 0);
        const finaltotmtr = newTotmtr + newTotmtrprev;
        setNewLumprows(prevRows => [...prevRows, ...selectedRows]);
        setNewTotMtr(finaltotmtr);
        const updatedRows = lumpRows.filter(row => !row.selected);
        const prevTotmtr = updatedRows.reduce((acc, row) => acc + parseFloat(row.mtr), 0);
        setLumpTotMtr(prevTotmtr);
        setLumpRows(updatedRows);
    };

    const handleRemoveLumps = () => {
        let filteredRows = newLumprows.filter((row) => !row.selected2);
        filteredRows = filteredRows.map(row => ({
            ...row,
            selected: false,
            selected2: false
        }));
        setNewLumprows(filteredRows);
        const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        setNewTotMtr(totmtr);

        let filteredRow2 = newLumprows.filter((row) => row.selected2);
        filteredRow2 = filteredRow2.map(row => ({
            ...row,
            selected: false,
            selected2: false
        }));
        setLumpRows(prevRows => [...prevRows, ...filteredRow2]);
        const prevTotmtr = filteredRow2.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        setLumpTotMtr(prevTotmtr);
    };

    const userId = '1';

    function PostObj(lumpRows, newLumprows, userId) {
        const data = {
            lumpRows: lumpRows,
            newlumpRows: newLumprows,
            userId: userId
        };
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const postData = PostObj(lumpRows, newLumprows, userId);
        console.log(postData);

        const resend = {
            baleId: Id,
            totmtr: newTotMtr
        };

        if (window.opener && window.opener.handleResendFromChild3) {
            window.opener.handleResendFromChild3(resend);
        }

        dispatch(insertClothIssueLump(postData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Record Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <div className="lump-content">
                <h3>Lump Details </h3>

                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td> <input
                                        type="checkbox"
                                        checked={lumpRow.selected}
                                        onChange={() => handleLumpSelection(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            // onChange={(e) => handleLumpColor(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            // onChange={(e) => handleLumpMtr(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="button-group">
                    <button className="add" onClick={handleAddlump}>Add</button>
                </div>
                <h3>Issue Lumps</h3>

                <div className="button-group">
                    <button className="add" onClick={handleRemoveLumps}>Remove</button>
                </div>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newLumprows.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td><input
                                        type="checkbox"
                                        checked={lumpRow.selected2}
                                        onChange={() => handleLumpSelection2(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            // onChange={(e) => handleLumpColor(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            // onChange={(e) => handleLumpMtr(
                                            //     lumpIndex,
                                            //     e.target.value
                                            // )}
                                            readOnly
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{newTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button className="add" onClick={handleSubmit}>Submit</button>
            </div>
        </>
    );
}

export default ClothIssueLump;
